var _defs, _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path3, _rect0;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "861B9F52-93F0-4AA5-B9C1-0D952B203D5A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.357002%",
    y1: "-6.50887574%",
    x2: "82.642998%",
    y2: "106.508876%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.7,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CMHC_UI-Kit_Iconography",
    transform: "translate(-644.000000, -3507.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-microsoft-office-/-word",
    transform: "translate(644.000000, 3507.000000)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "_142",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ambient-2",
    transform: "translate(10.000000, 1.666667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0.866666667,
    y: 1.46666667,
    width: 28.4,
    height: 32.8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABTCAYAAAA8/EEfAAAABGdBTUEAALGOfPtRkwAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAAEsAAAAAQAAASwAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAEigAwAEAAAAAQAAAFMAAAAA0m2kYAAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAllJREFUeAHtnMtKA0EURBMNCm5U0IWg3+HGnb8uiPoZKgqK4jK+YtVkepgJwQPunK4LRfd0DYF7qJ7s7nSxWEz6NVX1n2vZi8MQRNv4tJy3YGY635I2pVpAGcyX9C59roJqALVwtvXCoXQs7Uo1QCpw3tTvnfQkzfuQnBiXV8M5lc6kE8lJqqGcnFvpQrqSHqUPqalZmx7DcHIM51w6kgo8bUddn+ruoe3wXuuLmHRXrUDwdfK1cnIMZ0/akGqo77ZJ914+LV3fBZA/yN47SV4Np5aPtHvt9z7ou5aUiMHfKoCAWwAFEBAAOwkKICAAdhIUQEAA7CQogIAA2ElQAAEBsJOgAAICYCdBAQQEwE6CAggIgJ0EBRAQADsJCiAgAHYSFEBAAOwkKICAANhJUAABAbCToAACAmAnQQEEBMBOggIICICdBAUQEAA7CQogIAB2EhRAQADsJCiAgADYSVAAAQGwk6AAAgJgJ0EBBATAToICCAiAnQQFEBAAOwkKICAAdhIUQEAA7CQogIAA2ElQAAEBsJOgAAICYCdBAQQEwE6CAggIgJ0EBRAQALskyAMXPS6vmUapde3YTvit/2r/2nuZgudRnWUa5bP2O5Incw4mwul5bGU4c8k930lmYBZdzTyWU4MVnRy/cCntt+6B1gKwPRrd4ltjONeSezeD93WjSv2i55jeSK5X6Vga+7jSfjDcuxmYRVer04B9rWoZeOvr1f+0GM5g0K0pdYCaB901rb5WTk5N04CbP6f+1TIP1wDQ8kiHS1DlcfTrOjCl6bWAipl1MvkB/sZ/UtEkmBsAAAAASUVORK5CYII="
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 2.28333333,
    y: 1.65,
    width: 25.35,
    height: 30.05,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    style: {
      mixBlendMode: "multiply"
    },
    x: 1.53333333,
    y: 1.33333333,
    width: 26.8,
    height: 31.2,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABPCAYAAABS1GNxAAAABGdBTUEAALGOfPtRkwAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAAEsAAAAAQAAFjgAAAATAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAESgAwAEAAAAAQAAAE8AAAAARALk5AAAAAlwSFlzAAAuIwAALgoBPOOgnQAAAa9JREFUeAHt3LFNBDEQheE1QtomyK4JMjIaIqMAMgoiI6QCIi67IiBaZix79/RLNMD8lszeMyT+7i3htG3bFtchcHt8XJbW2hr5LnY+q6yfuOglipHPpc2GDIz7OHuOnShV1iUu+hL7o6MkyEA5xeFb7O/Y+R5V2Xnf99gPsdeJka/IY+yv2FUgru+ZKFmG0038yJWvyNN4Zq629v+dE2Q/qCbB+04QnpfNguCrF0QQCCDaEEEggGhDBIEAog0RBAKINkQQCCDaEEEggGhDBIEAog0RBAKINkQQCCDaEEEggGhDBIEAog0RBAKINkQQCCDaEEEggGhDBIEAog0RBAKINkQQCCDaEEEggGhDBIEAog0RBAKINkQQCCDaEEEggGhDBIEAog0RBAKINkQQCCDaEEEggGhDBIEAog0RBAKINkQQCCDaEEEggGhDBIEAog0RBAKINuQPkD7cLH7Xh5vhbyrE4/5jhln1sV05rizHlq199F9OeItJd+c4+Bx1yDFeifTf12xG3vvcHUZDrucg5sS7KjPNcuzfa2LE7vMQ91mIcdBXsQGRvSHZjHn/X7bRBPwo2jtNAAAAAElFTkSuQmCC"
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 2.28333333,
    y: 1.65,
    width: 25.35,
    height: 30.05,
    rx: 0.85
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6833333,33.3333333 L36.2166667,33.3333333 C36.590849,33.3377882 36.9512412,33.1922576 37.2174079,32.9292223 C37.4835746,32.666187 37.6333333,32.3075422 37.6333333,31.9333333 L37.6333333,25.85 L12.2833333,25.85 L12.2833333,31.95 C12.2833333,32.3197888 12.4313358,32.6741946 12.694377,32.9341044 C12.9574182,33.1940142 13.3135713,33.3377886 13.6833333,33.3333333 Z",
    id: "Path",
    fill: "#103F91",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2166667,3.33333333 L13.6833333,3.33333333 C13.3106637,3.32881563 12.9519373,3.47486403 12.6884007,3.73840065 C12.424864,4.00193727 12.2788156,4.36066365 12.2832316,4.73333333 L12.2832316,10.8333333 L37.6333334,10.8333333 L37.6333334,4.71666667 C37.6333334,4.34393478 37.4831311,3.98693111 37.2164511,3.72652594 C36.9497711,3.46612077 36.5892903,3.32435183 36.2166667,3.33333333 Z",
    id: "Path",
    fill: "#41A5EE",
    fillRule: "nonzero"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#185ABD",
    fillRule: "nonzero",
    x: 12.2833333,
    y: 18.3333333,
    width: 25.35,
    height: 7.51666667
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2B7CD3",
    fillRule: "nonzero",
    x: 12.2833333,
    y: 10.8166667,
    width: 25.35,
    height: 7.51666667
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ambient-3",
    transform: "translate(0.000000, 6.666667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.48,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    style: {
      mixBlendMode: "multiply"
    },
    x: 1.56666667,
    y: 1.16666667,
    width: 23.6,
    height: 23.6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAABGdBTUEAALGOfPtRkwAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAAEsAAAAAQAAASwAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAADygAwAEAAAAAQAAADwAAAAA3rOtQAAAAAlwSFlzAAAuIwAALiMBeKU/dgAABLJJREFUaAXtmolu2zAQRJ3e932g//91RZui6X0mnUdr5BVNialjS1GrBbakeGkfZ+kUEI/Ozs5W/5Nd2wX2SLbLvH3OkVA7KXU0NC+ARcBY3yfDLmsZOpXn2YRe4AYWuCtyylh3cFPAR0jq+GlTpuch8CKwYIG0X1U9etyAqYAN+lux5Q78aR/01hkOsPRdl98IThvuzVA1KU85hgGKAQXoL/lP+Y/gPK/EUYTuADdpDAztN+W35Hfkd+W35bSxASgeldbjKGZlAQYW0K/yL8HJOtqL0C1wA+tzirIA3pc/bPyBSuDZBPqBjikd6+raq1lZFrW6KAnsJ/kH+Xs5MWHeGJfrVv3bAjctVhcVgQP2ufyZ/EnzzEZElfU4mhkAdb/LP8tP5Mdys8QzfYqQ8Tx7kMa3v8TsEqlLGj+SA/xK/kL+WH5PDjBzUfWQymr5jgHsdAb4o/ydnHgxbwR9pDXPHYvAdKAwwAChJGn8VP5SDjR10pwXOKWnAEbFb3JSmSOGAYnibAIl8cHDBrFRyXJggmcgZ5SFUBlolCWt8amBCR7lALay1Eltsg+hSr8xam7yPvxgARxV9q80C+HAXgZgFCYLMZQlJv8l8XErZmCuMAtEaPrZLRZhN6MXF9SYQ5p/tADGOKeI4riIlZg7scUfrhzY55EygrOA3Qt6UXWNaj6PvN+xULpOhuJmUXVjDMrNsHkZF4p9+fwxnuP7Y1wR1GM68TDgPMbkaPlz7Bujbpi85N1uK8ZRA54arBj0RRprwBdZe4q5VYH+NeDqJi/A1S2a+YBF4ZkLWA1/Ubi6RTMfsCg8cwGr4S8KV7do5gMWhWcuYDX8ReHqFs18wKLwzAWshr8oXN2imQ9YFJ65gNXwF4WrW3S5B/gzTG+UNYWrC/SufEk7asAOOwfPnz1urJL3l5z3u70YS+ljWj7JcF4olsVFD9wY30+dL/z+yu+SEDyOems5sAe59GLxoojrLDL44ap9y/4qjssxcBOAOqXrjpmxW5YDMyAuyiJcD/LlL762+8v7FN+HY2xcc7ATF06cBvfY1dYtHhr0lVxjEyw75F1jERblkgjuCyR8eZ8SGCji4lIL7oss3Nvy7R0YWmjVk0WF3QkwOwUsN9xYjEtfXBbBeBEqTwVsQQz8VrFwdYlLLVxSA5r4DazqxiIwrUAzkAmGjfegWIzLI74lo2r5agEdBzDiAxiFEQQxiO+1/FiO2sSNynAwljmtRWAvxkCry675zNKG0qQ1wPxJq36P1Zh9GjHiBuaYESOwb+TEF4E7sOpLF0EobV6MHWIiC2A8s3tcR+TGDBsV/4YfGjwG7pQmC8k40pjYiDVXmJ+nOHcDTAfXEjUpprQe024Cz04a1uf30KC8Pxrx4U5rhACa+OycbTZjK53VtupcEA8X1AAibXHf0fJzhJ0CWCElGIQhtYED3M5zOr+5umrvAqeG9d8nQEhZ4EhfSpw2n92xYfXqZFbZ2QhcdJQtXg5ndkdhGrCgNFCGd92gLtOcEf8BFIvgTt/UVlJ2PaUHuO1cq82j4Vx6yNRlhO/8j6ovsKLCfYNpb9QfGjJK35CKQwH8NfDQYnPoi39L5xDvhWP8A026r3wLq0TdAAAAAElFTkSuQmCC"
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 4.76666667,
    y: 3.21666667,
    width: 16.9,
    height: 16.9,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.24,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(3.333333, 1.666667)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    style: {
      mixBlendMode: "multiply"
    },
    x: 1,
    y: 1.06666667,
    width: 18,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAABGdBTUEAALGOfPtRkwAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAAzwAAAACwAADPAAAAALAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAC6gAwAEAAAAAQAAAC4AAAAAGePEcgAAAAlwSFlzAAAuTgAALk4BHJw2GAAAAQJJREFUaAXtmbENwkAUQ+8QUpagS8cEdOzFAOxER5kF2CBDQHXYgUi4pbBykr/kXHyNraek+rW1VmqtQynlAPHc4rxQakZXnstUPFn2BF0glt/izCh1habf8iMubtATahsVu92hMzTwK+EcoQe01dJrL5Yn4JHFd3jpZeQ/7Km4AE5xwWEwIW6ALBEhLjgMJsQNkCUixAWHwYS4AbJEhLjgMJgQN0CWiBAXHAYT4gbIEhHigsNgQtwAWSJCXHAYTIgbIEtEiAsOgwlxA2SJCHHBYTAhboC8LGmRsyxpSVwuDAX+iWDHCeKSlsvasv++8ILTzWa5ctnZ5S5/XS9/gPfzfANxTodLWKK/ogAAAABJRU5ErkJggg=="
  }), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 1.43333333,
    y: 1.55,
    width: 16.9,
    height: 16.9,
    rx: 0.85
  })))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#185ABD",
    fillRule: "nonzero",
    x: 4.76666667,
    y: 9.88333333,
    width: 16.9,
    height: 16.9,
    rx: 0.85
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light"
    },
    transform: "translate(3.333333, 8.333333)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1.43333333,
    y: 1.55,
    width: 16.9,
    height: 16.9,
    rx: 0.85
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.55,20.6833333 C10.55,20.9 10.55,21.0833333 10.55,21.25 L10.55,21.25 C10.55,21.1 10.55,20.9166667 10.55,20.7 C10.5740055,20.5138225 10.6130214,20.3298902 10.6666667,20.15 L12.1333333,13.75 L14.05,13.75 L15.7333333,20 C15.830098,20.3887631 15.89696,20.7843633 15.9333333,21.1833333 L15.9333333,21.1833333 C15.9333333,20.85 16.0166667,20.4666667 16.1,20.0333333 L17.3166667,13.7 L19.0666667,13.7 L16.9166667,22.8666667 L14.9,22.8666667 L13.4333333,16.8 C13.4333333,16.6166667 13.35,16.4 13.3,16.1166667 C13.25,15.8333333 13.2166667,15.6333333 13.2,15.5 L13.2,15.5 C13.2,15.65 13.2,15.8666667 13.1,16.1666667 C13,16.4666667 13.0166667,16.6666667 12.9833333,16.8166667 L11.6666667,22.9166667 L9.51666667,22.9166667 L7.35,13.75 L9.11666667,13.75 L10.45,20.1666667 C10.4928221,20.336916 10.5262063,20.5094011 10.55,20.6833333 L10.55,20.6833333 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.76666667,
    y: 1.43333333,
    width: 33.8,
    height: 33.8
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/Word.cc17bb762f8ad9d31222d7985399d4c0.svg";
export { ForwardRef as ReactComponent };